import { render, staticRenderFns } from "./template-dialog.vue?vue&type=template&id=757f53d7&scoped=true"
import script from "./template-dialog.vue?vue&type=script&lang=js"
export * from "./template-dialog.vue?vue&type=script&lang=js"
import style0 from "./template-dialog.vue?vue&type=style&index=0&id=757f53d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757f53d7",
  null
  
)

export default component.exports